import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { SharedLoaderService } from './sharedLoader/shared-loader.service';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {

  constructor(private loaderService: SharedLoaderService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
  const skipLoader = request.url.includes('/Master') || request.url.includes('/Settings')
                              || request.url.includes('/Security') || request.url.includes('/assets/')
                              || request.url.includes('/api/v1/accounting/');

  if (!skipLoader) {
    this.loaderService.show();
  }

  return next.handle(request).pipe(
    finalize(() => {
      if (!skipLoader) {
        this.loaderService.hide();
      }
    })
  );
}
}
